import { Component, ComponentInterface, h, Host, JSX, Listen, Prop } from '@stencil/core';
import { SharedDirectionService } from '../../global/workbench-global';
import { DEFAULT_WORKBENCH_THEME, WorkbenchTheme } from '../../shared/themes';

@Component({
  tag: 'wb-skeleton',
  styleUrl: './skeleton.scss',
  shadow: true,
})
export class SkeletonComponent implements ComponentInterface {
  /** the colour scheme */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme = DEFAULT_WORKBENCH_THEME;

  /** @internal if present sets the direction of the element to rtl */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  public connectedCallback() {
    this.updateDirection();
  }

  public render(): JSX.Element {
    return <Host class="wb-skeleton" />;
  }
}
